import { render, staticRenderFns } from "./gauntlet.vue?vue&type=template&id=16af1e73&"
import script from "./gauntlet.vue?vue&type=script&lang=js&"
export * from "./gauntlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports